import type { AppConfigInput } from '@nuxt/schema'

export default {
  link: {
    base: 'underline',
  },
} as AppConfigInput['ui']
